import { render, staticRenderFns } from "./PickCoordinateFloraFauna.vue?vue&type=template&id=6d1b4c56"
import script from "./PickCoordinateFloraFauna.vue?vue&type=script&lang=js"
export * from "./PickCoordinateFloraFauna.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports